import {AbstractDeviceConsumableWithSuppMapper} from "../abstract-device-consumable-with-supp.mapper";
import {PricingItem} from "../../../../../domain/in/quote/pricing-item/pricing-item";
import {EnumPricingItemType} from "../../../../../domain/in/quote/pricing-item/pricing-item-type";

export abstract class AbstractDiscoStandardMapper extends AbstractDeviceConsumableWithSuppMapper {

    protected getFranchiseConso(pricingItem: PricingItem): string | undefined {
        if (pricingItem.pricingItemType == EnumPricingItemType.DEVICE_CONSUMABLE_WITH_SUPP
            || pricingItem.pricingItemType == EnumPricingItemType.CONSUMABLE) {
            return pricingItem.userInputs.franchiseConso;
        }
        return '';
    }

}
